<template>
    <div >
        <div class="item" v-for="item in listIssue"   @click="linkUrl(item)">
            <div class="img"><img :src="item.img" alt=""></div>
            <div class="handle">
                <div class="name">{{item.name}}</div>
                <span>{{item.desc}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getlogin,getModelList,AddModel,getModelState,getModelView
    } from "../api/common"
    export default {
        name: "Login",
        data() {
            return {
                active:0,
                dialogFormVisible: false,
                form: {
                    name: '',
                },
                formLabelWidth: '90px',
                list:[],
                imageUrl: '',
                imageFile:"",
                file:"",
                rules: {
                    name: [
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                },
                listIssue:[
                    {
                        name:"鲁泰控股办公大楼",
                        desc:"山东鲁泰控股集团",
                        img:require('../assets/images/lt.jpg'),
                        url:"http://local.vrmaker.vip:38080/wisdom_building/#/"
                    },{
                        name:"昌华工业园电力监控与运维平台",
                        desc:"武汉昌华电气设备集团",
                        img:require('../assets/images/ch.png'),
                        url:"http://local.vrmaker.vip:38080/ebs-ch3D/#/?all"
                    },{
                        name:"ZEA",
                        desc:"cad-viewer-staging.zea.live",
                        img:require('../assets/images/img3.png'),
                        url:"https://cad-viewer-staging.zea.live/?zcad=data%2FRod+with+PMI.zcad"
                    },
                ]
            }
        },
        watch: {

        },
        mounted() {
            this.getList()
        },
        methods: {
            linkUrl(item){
                let href = item.url
                window.open(href, '_blank');
            },
            review(item){
                this.getFileState(item.fileId)
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.4)'
                    });
                    let obj = {
                        name: this.form.name,
                        projectId: this.$route.query.id,
                        thumbnail:this.imageFile,
                        modelFile:this.file
                    }
                    AddModel(obj).then((res) => {
                        if (res.data.code==200) {
                            loading.close();
                            this.$message({
                                showClose: true,
                                message: '恭喜你，创建成功！',
                                type: 'success'
                            });
                            this.getList()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
                });
            },
            onProgressModel(res,file){
                console.log(res)
                this.file = res.raw
            },
            onProgressImg(res,file){
                this.imageFile = res.raw
                this.imageUrl = this.getObjectURL(res.raw)
            },
            getReview(fileId){
                 const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                getModelView(fileId).then((res) => {
                    if (res.data.code==200) {
                        loading.close();
                         this.$router.push({
                            path:'/View',
                            name:'View',
                            query:{viewToken:res.data.data.viewToken}
                        })
                    }
                })
            },
            getFileState(fileId){
                getModelState(fileId).then((res) => {
                    if (res.data.code==200) {
                        if(res.data.data.status=="success"){
                            this.getReview(fileId);
                        }else{
                            this.$message('正在转换模型中，请稍后预览！');
                            return
                        }
                    }
                })
            },
            getObjectURL(file) {
                var url = null ; 
                if (window.createObjectURL!=undefined) { // basic
                    url = window.createObjectURL(file) ;
                } else if (window.URL!=undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file) ;
                } else if (window.webkitURL!=undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file) ;
                }
                return url ;
            },
            getList(){
                let obj = {
                    pageNo:1,
                    pageSize:10,
                    projectId:this.$route.query.id
                }
                getModelList(obj).then((res) => {
                    this.list = res.data.data.content;
                    this.dialogFormVisible = false
                })
            }
        }
    };
</script>
<style scoped lang="less">
.main{
    padding: 5vh 10vw;
    overflow: hidden;
    .tag{
        font-size: 18rem;
        line-height: 30px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        span{
            padding: 3px 10px;
            position: relative;
            cursor: pointer;
        }
        .active::before{
            content: "";
            border-bottom: 2px solid #0D94FF;
            position: absolute;
            bottom: -3px;
            width: 40px;
            left: 50%;
            margin-left: -20px;
            z-index: 9;
            display: inline-block;
        }
    }
}
    .project{
        width: 110%;
        overflow: hidden;
        padding-bottom: 23px;
    }
    .newbtn{
        margin-top: 20px;
    }
    .upload{
        height: 240rem;
        background: #EEEEEE;
        border: 1px solid #DCDCDC;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        .icon{
            margin-top: 50rem;
        }
        /deep/.avatar-uploader{
            height: 100%;
        }
        /deep/.el-upload{
            width: 100%;
            height: 100%;
        }
    }
    .add{
        width: 19vw;
        height: 290px;
        border-radius: 12px;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        text-align: center;
        font-size: 18px;
        color: #999999;
        text-align: center;
        cursor: pointer;
        img{
            color: #D2D2D2;
            width: 52px;
            margin-top: 80px;
        }
        &>div{
            margin-top: 20px;
        }
    }
    .item{
        width: 19vw;
        height: 290px;
        overflow: hidden;
        border-radius: 12rem;
        background: #FFFFFF;
        float: left;
        margin-right: 25px;
        box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.1000);
        margin-top: 36px;
        display: inline-block;
        cursor: pointer;
        transition:all .5s;-webkit-transition:all .5s;-ms-transition:all .5s;
        .img{
            height: 200px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .handle{
            padding: 10px 10px;
            .name{
                font-size: 18px;
                margin-bottom: 10px;
                img{
                    width: 18px;
                    float: right;
                    margin-left: 20px;
                    cursor: pointer;
                    display: none;
                }
            }
            span{
                font-size: 16rem;
                color: #666;
                display: inline-block;
            }
        }
    }
        .item:hover{
            -webkit-transform: translateY(-20px);
            -moz-transform: translateY(-20px);
            -ms-transform: translateY(-20px);
            -o-transform: translateY(-20px);
            transform: translateY(-20px);
            .name img{
                display: inline-block;
            }
        }
</style>


// WEBPACK FOOTER //
// src/components/issueProject.vue